<template>
    <div class="panel modalDetailsPanel">
        <p>
                            
            <template v-for="contact in contacts">
                
                <strong>{{ contact.fullname }}</strong><br />
                {{ contact.organisationName }}<br />
                <a :href="`mailto:${contact.email}`">{{ contact.email }}</a><br />
                {{ contact.phone }}<br /><br />
                    
            </template>

        </p>
    </div>
</template>

<script>
export default {
    props: {
        contacts: {
            type: Array,
            required: true
        }
    }
}
</script>


<style scoped>
p a {    color: var(--base-color-3);}
</style>